export const skills = [
  "React Js",
  "Next Js",
  "Vue Js",
  "Flutter",
  "Python",
  "Django",
  "React native",
  "Laravel",
  "Node Js",
  "Express Js",
  "Java",
  "Wordpress",
  "Figma"
];
